import type { LucideIcon } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface KpiStatCardProps {
  label: string
  value: number | string
  description?: string
  icon?: LucideIcon
  format?: 'number' | 'percent'
}

export function KpiStatCard({
  label,
  value,
  description,
  icon: Icon,
  format = 'number',
}: KpiStatCardProps) {
  const displayValue =
    format === 'percent' && typeof value === 'number' ? `${(value * 100).toFixed(1)}%` : value

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{label}</CardTitle>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{displayValue}</div>
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </CardContent>
    </Card>
  )
}
